// extracted by mini-css-extract-plugin
export default {"backAnchor":"InvoiceDetailView_backAnchor__E27+P","backAnchorIcon":"InvoiceDetailView_backAnchorIcon__jTk3j"};